export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13576.48336f28.jpg";